import React from 'react';
import { InitiativeDetails as InitiativeDetailsComponent } from '../components/InitiativeDetails/Loadable';

const InitiativeDetails = () => {
  return <InitiativeDetailsComponent />;
};

export default InitiativeDetails;
